<template>
  <!-- 2026-09-08：后台测试人员先完成普通账号认证，再由服务端确认本轮维护资格。 -->
  <section class="tester-login">
    <h2>管理端维护测试登录</h2>
    <p>请使用已获授权的管理账号，登录后继续使用账号原有功能。</p>
    <form @submit.prevent="submit">
      <a-input v-model:value="username" aria-label="账号" placeholder="管理账号" autocomplete="username" :disabled="busy || checking" />
      <a-input-password v-model:value="password" aria-label="密码" placeholder="密码" autocomplete="current-password" :disabled="busy || checking" />
      <a-button type="primary" html-type="submit" :loading="busy || checking">登录并验证</a-button>
      <a-button :disabled="busy || checking" @click="$emit('cancel')">返回维护页</a-button>
    </form>
    <p v-if="error" role="alert">{{ error }}</p>
  </section>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import store from '@/store'
export default defineComponent({
  props: { checking: { type: Boolean, default: false } },
  emits: ['authenticated', 'cancel'],
  setup(_props, { emit }) {
    const username = ref(''), password = ref(''), busy = ref(false), error = ref('')
    const submit = async () => {
      if (busy.value || _props.checking) return
      if (!username.value.trim() || !password.value) { error.value = '请输入账号和密码。'; return }
      busy.value = true; error.value = ''
      try {
        await store.dispatch('user/login', { username: username.value.trim(), password: password.value })
        password.value = ''; emit('authenticated')
      } catch (reason: any) { error.value = reason?.message || '登录失败，请核对账号和密码。' }
      finally { busy.value = false }
    }
    return { username, password, busy, error, submit }
  }
})
</script>
<style lang="scss" scoped>
.tester-login { width: min(440px, calc(100% - 32px)); margin: 80px auto; padding: 28px; border: 1px solid #d9e9fa; border-radius: 14px; background: #fff; color: #172033; }
.tester-login p { color: #667085; line-height: 1.7; }
.tester-login form { display: grid; gap: 16px; }
</style>
